import React from "react";

export default function SixMinuteWalkAssessmentCard({
  title,
  body,
  primaryAction = null,
  secondaryAction = null,
  children = null,
  footer = null,
  scrollable = true,
}) {
  const hasHeader = Boolean(title) || Boolean(body);

  return (
    <div
      className={[
        "w-full max-w-lg h-full min-h-0 px-4",
        scrollable ? "overflow-y-auto" : "overflow-hidden",
      ].join(" ")}
    >
      <section
        className={[
          "flex flex-col gap-4",
          scrollable ? "min-h-full" : "h-full min-h-0",
        ].join(" ")}
      >
        {hasHeader ? (
          <header className="flex flex-col gap-1 text-left">
            {title ? <h1 className="subtitle-text">{title}</h1> : null}
            {body ? <p>{body}</p> : null}
          </header>
        ) : null}

        {children}

        {footer ? (
          footer
        ) : primaryAction || secondaryAction ? (
          <div className="mt-auto grid grid-cols-1 gap-2 pb-2">
            {primaryAction ? (
              <button
                type="button"
                className={primaryAction.className || "primary-button w-full"}
                onClick={primaryAction.onClick}
              >
                {primaryAction.label}
              </button>
            ) : null}

            {secondaryAction ? (
              <button
                type="button"
                className={
                  secondaryAction.className || "secondary-button w-full"
                }
                onClick={secondaryAction.onClick}
              >
                {secondaryAction.label}
              </button>
            ) : null}
          </div>
        ) : null}
      </section>
    </div>
  );
}
